import { Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Direction } from 'src/app/interfaces/interfaces.index';
import { wordMask } from '../../shared/config/imaskCommon';

@Component({
  selector: 'app-direccion',
  templateUrl: './direccion.component.html',
  styleUrls: ['./direccion.component.css']
})
export class DireccionComponent implements OnInit, OnChanges {

  @Input() address: UntypedFormGroup;
  @Input() id: string;
  @Input() editable: boolean;
  @Input() direccion: string;
  @Input() size: boolean;
  @Output() direction: EventEmitter<Direction> = new EventEmitter<Direction>();
  pattern = /#|-|No.|N°|N.|NO|NO.|,/g;
  apto: string;
  aptoNumber: string;
  neigh: string;
  neighField: string;
  wordMask=wordMask;
  @Input() oneField = false;
  streetList = [
    {name: "Calle", valueId: "Cll"},
    {name: "Carrera", valueId: "Cr"},
    {name: "Diagonal", valueId: "Dgal"},
    {name: "Transversal", valueId: "Trv"},
    {name: "Avenida", valueId: "Av"},
    {name: "Vereda", valueId: "Vr"},
    {name: "Manzana", valueId: "Mz"}
  ];
  apartmentList = [
    {name: "Bulevar", valueId: "Bl"},
    {name: "Apartamento", valueId: "Apto"},
    {name: "Interior", valueId: "Inte"},
    {name: "Casa", valueId: "Cs"},
    {name: "Oficina", valueId: "Of"}
  ];
  neighborhoodList = [
    {name: "Barrio", valueId: "Brr"},
    {name: "Comuna", valueId: "Cm"}
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.direccion?.currentValue !== null && changes.direccion?.currentValue !== undefined && this.oneField == false) {
      this.addressSplitting(changes.direccion.currentValue);
    }
    else if (changes.direccion?.currentValue !== null && changes.direccion?.currentValue !== undefined && this.oneField == true) {
      this.address.get('inlineAddress').setValue(changes.direccion.currentValue);
      this.setInlineAddress();
    }
  }

  addressSplitting(direccion: string) {
    const direction = direccion.replace(this.pattern, ' ');
    const directionSplited = direction.split(' ');
    const directionFiltered = directionSplited.filter(item => item !== '');

    directionFiltered[0] = this.streetValidation(directionFiltered[0]);
    directionFiltered[4] = this.apartmentValidation(directionFiltered[4]);
    directionFiltered[6] = this.neighborhoodValidation(directionFiltered[6]);

    this.street.setValue(directionFiltered[0]);
    this.streetNumber.setValue(directionFiltered[1]);
    this.houseNumber.setValue(directionFiltered[2]);
    this.oficeNumber.setValue(directionFiltered[3]);
    this.apartment.setValue(directionFiltered[4]);
    this.apartmentNumber.setValue(directionFiltered[5]);
    this.neighborhood.setValue(directionFiltered[6]);
    this.neighborhoodField.setValue(directionFiltered[7]);
    this.addressConstruction();
  }

  streetValidation(street : string): string {
    switch (street){
      case 'CALLE' || 'Calle' || 'Cl' || 'CL':
        street = 'Cll';
        break;

      case 'CRA' || 'CARRERA' || 'CR':
        street = 'Cr';
        break;

      case 'MANZANA' || 'MZ' || 'MAZ':
        street = 'Mz';
        break;

      case 'DIAGONAL' || 'DIG':
        street = 'Dgal';
        break;

      case 'TV':
        street = 'Trv';
        break;

      case 'VEREDA' || 'VDA':
        street = 'Vr';
        break;

      case 'AV':
        street = 'Av';
        break;
    }
    return street;
  }

  apartmentValidation (apartment: string): string {
    switch (apartment){
      case 'AP' || 'APT':
        apartment = 'Apto';
        break;

      case 'IN':
        apartment = 'Inte';
        break;

      case 'BL':
        apartment = 'Bl';
        break;
    }
    return apartment;
  }

  neighborhoodValidation (neighborhood: string): string{
    switch (neighborhood){
      case 'BRR':
        neighborhood = 'Brr';
        break;
    }
    return neighborhood;
  }

  addressConstruction() {

      const { street, streetNumber , houseNumber, oficeNumber, apartment,
              apartmentNumber, neighborhood, neighborhoodField
            } = this.address.value;

      (apartment === undefined) ? this.apto = '' : this.apto = apartment;
      (apartmentNumber === undefined) ? this.aptoNumber = '' : this.aptoNumber = apartmentNumber;
      (neighborhood === undefined) ? this.neigh = '' : this.neigh = neighborhood;
      (neighborhoodField === undefined) ? this.neighField = '' : this.neighField = neighborhoodField;

      const dir: Direction = {
        id: this.id,
        direccion: `${street} ${streetNumber} ${houseNumber} ${oficeNumber} ${this.apto} ${this.aptoNumber} ${this.neigh} ${this.neighField}`,
      };
      this.direction.emit(dir);

  }

  setInlineAddress() {
    const { inlineAddress } = this.address.value;

    const dir: Direction = {
      id: this.id,
      direccion: inlineAddress,
    };
    this.direction.emit(dir);
  }


  get street() { return this.address.get('street'); }
  get streetNumber() { return this.address.get('streetNumber'); }
  get houseNumber() { return this.address.get('houseNumber'); }
  get oficeNumber() { return this.address.get('oficeNumber'); }
  get apartment() { return this.address.get('apartment'); }
  get apartmentNumber() { return this.address.get('apartmentNumber'); }
  get neighborhood() { return this.address.get('neighborhood'); }
  get neighborhoodField() { return this.address.get('neighborhoodField'); }
}
